<template>
  <div class="ManageGroupCourse">
    <div class="container-fluid padding-right-0px">
      <manage-group-course-filter @selectedGroupObj="updateSelectedGroupObj"></manage-group-course-filter>
      <manage-group-course-details v-if="showCourseMasterList" v-bind:groupCourseMasterList="groupCourseMasterListValue" @refreshGCMList="refreshGCMList" @showSpinner="showSpinnerValue"></manage-group-course-details>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div> 
      <loader></loader>  
      </div>
  </div>
</template>

<script>
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import AlertBox from '@/components/AlertOverlay'
import ManageGroupCourseFilter from '@/components/ManageGroupCourseFilter'
import ManageGroupCourseDetails from '@/components/ManageGroupCourseDetails'
import Loader from '@/components/dashboard/Loader'
export default {
  data: function () {
    return {
      selectedGroupObj: -1,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      groupCourseMasterList: null,
      showCourseMasterList: false
    }
  },
  components: {
    'manage-group-course-details': ManageGroupCourseDetails,
    'manage-group-course-filter': ManageGroupCourseFilter,
    'alert-box': AlertBox,
    'loader': Loader
  },
  methods: {
    showSpinnerValue (value) {
      // AK: show and hide spinner
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    refreshGCMList (value) {
      // AK: Refresh GCM List after Deleting GCM
      this.getGroupCourseMasterList()
    },
    updateSelectedGroupObj (newValue) {
      // AK: when user pressed go then set selectedGroupObj
      this.selectedGroupObj = newValue
      // AK: get group course list
      this.getGroupCourseMasterList()
    },
    getGroupCourseMasterList: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedGroupObj !== -1) {
        // AK: Start showing spinner to user
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        groupCourseService.listGroupCoursesMaster(storeObj.state.access_token, this.selectedGroupObj.GroupId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Course Master list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              // AK: Store it
              this.groupCourseMasterList = responseObj.data
              // AK: show alert if no courses found
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No course(s) found for select \'' + this.selectedGroupObj.GroupName + '\' group.'
                // AK: Show List to user
                this.showCourseMasterList = false
              } else {
                // AK: Show List to user
                this.showCourseMasterList = true
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING COURSE MASTER LIST')
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  computed: {
    groupCourseMasterListValue: {
      get: function () {
        return this.groupCourseMasterList
      }
    }
  },
  name: 'ManageGroupCourse'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ManageGroupCourse {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/ManageGroupCourse.vue